<aside class="
  col-12 col-xs-12 col-sm-5 col-md-4
  right-navigation
  float-right
  my-acc-aside
" style="height: fit-content;">
  <section class="bgWhite">
    <app-acc-my-account></app-acc-my-account>
  </section>
  <div class="line-divider" *ngIf="!!marketingNbaBanner?.cmsResponse && !!marketingNbaBanner?.imageUrl"></div>
  <section class="bgWhite alignCenter">
    <app-my-acc-overview-marketing-nba-banner></app-my-acc-overview-marketing-nba-banner>
  </section>
  <div class="line-divider" *ngIf="!!saveOrderBanner?.cmsResponse && !!saveOrderBanner?.imageUrl"></div>
  <section class="bgWhite alignCenter">
    <app-my-acc-overview-save-order-banner></app-my-acc-overview-save-order-banner>
  </section>
  <div *ngIf="isFutureshipUser" class="line-divider"></div>
  <section class="bgWhite alignCenter d-block" *ngIf="isFutureshipUser"
    [ngClass]="{'vsh':baseSiteId=='vsh','vax':baseSiteId=='vax'}">
    <div class="futureship-wrapper">
      <div [innerHTML]="futureShipContent"></div>
      <button type="button" class="btn-primary blue-button" (click)="openFutureShipmentModal()">Schedule now</button>
    </div>
    <a [href]="futureShipContent2?.downloadUrl" *ngIf="futureShipContent2?.url" target="_self">
      <img [src]="futureShipContent2?.url" [alt]="futureShipContent2?.altText"
        [ngStyle]="{'display': 'block', 'margin':'8px auto'}">
    </a>
  </section>
  <div class="line-divider"></div>
  <section class="displayNo col-xs-12 col-sm-7 col-md-12 quick-order-sec bgWhite">
    <app-order-products *ngIf="!punchOutKey"></app-order-products>
  </section>
  <div class="line-divider-top0"></div>
  <section class="bgWhite notification">
    <app-acc-notification></app-acc-notification>
  </section>

  <div class="line-divider-top0"></div>

  <section class="bgWhite notification">
    <app-offer-notification></app-offer-notification>
  </section>

  <div class="line-divider-top0"></div>

  <section class="bgWhite">
    <app-my-acc-overview-ad-banner></app-my-acc-overview-ad-banner>
  </section>
</aside>